import React from 'react';
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";
import { useQRStore } from '../../stores/qrStore';


export default function FormQRCodeOverlay({ output, handleVisibility, isVisible }) {
    const QRSettings = {};
    QRSettings.bgColor = useQRStore( state => state.bgColor )
    QRSettings.fgColor = useQRStore( state => state.fgColor )
    QRSettings.level = useQRStore( state => state.level )
    QRSettings.size = useQRStore( state => state.size )
    QRSettings.render = useQRStore( state => state.render )

    const QRCode = QRSettings.render === 'svg' ? QRCodeSVG : QRCodeCanvas;

    const toggleQRVisibility = (e) => {
        const wrapper = e.currentTarget.parentElement.parentElement;

        wrapper.classList.remove('fadeIn');
        wrapper.classList.add('fadeOut');

        setTimeout( () => {
            handleVisibility();
        }, 150);
    }

    const handleDownload = () => {
        const link = document.createElement('a');
        let image;

        if(QRSettings.render === 'canvas') {
            image = document.querySelector(".qr-wrapper > *").toDataURL("image/png")
                .replace("image/png", "image/octet-stream");

            link.href = image;
            link.download = 'paramasaur-qr.png';
        } else {
            image = document.querySelector(".qr-wrapper svg");
            image.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

            const blob = new Blob([image.parentElement.innerHTML]);
            link.href = window.URL.createObjectURL(blob);
            link.download = 'paramasaur-qr.svg';
        }

        link.click();
    }


    return(
        <div className={`qr-overlay-wrapper ${isVisible ? 'fadeIn' : 'hidden'}`} >
            <div className="qr-canvas">
                <button className="btn btn-icon" onClick={toggleQRVisibility}><span className="material-icons md-24">close</span></button>
                <div className="qr-wrapper">
                    <QRCode
                        value={output} 
                        bgColor={QRSettings.bgColor} 
                        fgColor={QRSettings.fgColor} 
                        level={QRSettings.level} 
                        size={Number(QRSettings.size)}
                    />
                </div>
                <button type="button" className="btn btn-copy" onClick={handleDownload}>Copy / Download</button>
            </div>
        </div>
    )
}